<template>
  <div class="col-lg-12 mx-auto">
    <div class="row ">
      <div class="col-md-12 mb-4">
        <div class="">
          <label class="form-label"
                 for="autocomplete">{{ $t('Address') }}</label>
          <input type="text"
                 class="form-control"
                 id="autocomplete" name="address"
                 :disabled="disableMode === 2"
                 v-model="address">
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="col-md-6 mb-4">
        <div class="">
          <label class="form-label"
                 for="latitude">{{ $t('Latitude') }}</label>
          <input type="text"
                 class="form-control"
                 id="latitude"
                 name="latitude"
                 v-model="latitude" :readonly="disableMode === 1"
                 onkeypress='validateNumAndSpecChars(event)'>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <div class="">
          <label class="form-label"
                 for="longitude">{{ $t('Longitude') }}</label>
          <input type="text"
                 class="form-control"
                 id="longitude"
                 name="longitude"
                 v-model="longitude" :readonly="disableMode === 1"
                 onkeypress='validateNumAndSpecChars(event)'>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchPlace",
  props: {
    old: Object,
  },
  components: {},
  data: function () {
    return {
      address: null,
      latitude: null,
      longitude: null,
      disableMode: 0, //0 -none, 1-coords, 2-address
    }
  },
  methods: {
    onChangeCoords() {
      if (this.latitude !== '' && this.longitude !== '') {
        this.disableMode = 2;
      } else {
        this.disableMode = 0;
      }

      //if comes prefilled from old
      if (this.address !== null && this.address !== '') {
        this.disableMode = 1;
      } else if ((this.latitude !== null || this.longitude !== null) && (this.longitude !== '' || this.latitude !== '')) {
        this.disableMode = 2;
      }
    }
  },
  watch: {
    latitude: function (lat) {
      this.onChangeCoords(lat);
    },
    longitude: function (lng) {
      this.onChangeCoords(lng);
    },
    address: function (address) {
      if (address === '') {
        this.disableMode = 0;
      } else {
        this.disableMode = 1;
      }
    }
  },
  mounted() {
    console.log(this.old);
    if (this.old != null) {
      this.address = this.old.address;
      this.latitude = this.old.latitude;
      this.longitude = this.old.longitude;
    }
  }
}
</script>

<style scoped>

</style>
